import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllEvents } from "../../../../context/Slice/EventManagementSlice";
import "./EventMaster.css";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";
import { Button } from "@mui/material";

const EventMaster = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const allEvents = useSelector((state) => state.EventManagementR.Data);
  const [show, setShow] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const token = secureLocalStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const ID = decoded._id;
        dispatch(ShowAllEvents());
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    setSelectedEvent(event);
    setShow(true);
  };

  const handleAdd = () => {
    navigate("/admin-dashboard/ChangeCoordinator", {
      state: { selectedEvent },
    });
  };

 
  const convertToNumber = (budgetOption) => {
    // Helper function to convert "L" notation to actual numbers
    const lakhToNumber = (str) => Number(str.replace("L", "")) * 100000;
  
    // Helper function to extract numbers from strings (e.g., "5000-10000")
    const parseNumber = (str) => Number(str.replace(/[^0-9]/g, "")); // Remove non-numeric characters
  
    if (budgetOption.includes("-")) {
      // Case: Range like "1L-3L" or "5000-10000"
      const [minStr, maxStr] = budgetOption.split("-");
      const min = minStr.includes("L") ? lakhToNumber(minStr) : parseNumber(minStr);
      const max = maxStr.includes("L") ? lakhToNumber(maxStr) : parseNumber(maxStr);
      return { min, max, average: (min + max) / 2 };
    } else if (budgetOption.startsWith("<") || budgetOption.startsWith("Up to") || budgetOption.startsWith("Upto")) {
      // Case: "<1L", "<5000", "Upto 1L", "Upto 10000"
      const value = budgetOption.includes("L")
      ? lakhToNumber(budgetOption.replace(/<|Up to|Upto/g, "").trim()) * 0.75 // Assume 75% of the given value
      : parseNumber(budgetOption.replace(/<|Up to|Upto/g, "").trim()) * 0.75;
      return { min: value, max: value, average: value };
    } else if (budgetOption.startsWith(">")) {
      // Case: ">5L" or ">30000"
      const value = budgetOption.includes("L")
        ? lakhToNumber(budgetOption.substring(1)) * 1.2 // Assume 120% of given value
        : parseNumber(budgetOption.substring(1)) * 1.2;
      return { min: value, max: value, average: value };
    } else {
      // Case: Single value like "2L" or "10000"
      const value = budgetOption.includes("L") ? lakhToNumber(budgetOption) : parseNumber(budgetOption);
      return { min: value, max: value, average: value };
    }
  };
  
  const calculateTotalBudget = () => {
    let totalBudget = 0;
  
    if (selectedEvent && selectedEvent.Budget && selectedEvent.Budget.categories) {
      selectedEvent.Budget.categories.forEach((category) => {
        const convertedBudget = convertToNumber(category.price); // Convert category price
        totalBudget += convertedBudget.average; // Use the average budget for calculation
      });
    }
  
    return totalBudget;
  };
  

  const filteredEvents =allEvents && allEvents.filter(
    (event) =>
      event.EventName?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      (event.User.firstName + " " + event.User.lastName)
        ?.toLowerCase()
        .includes(searchTerm?.toLowerCase())
  );

  useEffect(() => {
    if (allEvents.length > 0) {
      const coordinatorEventCount = allEvents.reduce((acc, event) => {
        const coordinatorId = event.Coordinator_id; 
        if (coordinatorId) {
          acc[coordinatorId] = (acc[coordinatorId] || 0) + 1;
        }
        return acc;
      }, {});
  
      console.log("Events grouped by Coordinator:", coordinatorEventCount);
      localStorage.setItem("coordinatorEventCount", JSON.stringify(coordinatorEventCount));

    }
  }, [allEvents]);
  

  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/admin-dashboard");
  };

  return (
    <div id="EventMaster">
      <div>
        <h2 className="heading">Events </h2>
        {/* Back Button */}
        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <div className="searchField">
          <input
            type="text"
            placeholder="Search by Name or Event Name"
            className="searchInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="grid">
        {filteredEvents && filteredEvents.length > 0 ? (
          filteredEvents.map((event, index) => (
            <div className="card" key={index}>
              <div className="card-body">
                <h5 className="card-title fw-bold">{event.EventName}</h5>
                <p className="card-text">
                  <strong>Name:</strong> {event.User.firstName}{" "}
                  {event.User.lastName}
                </p>
                <p className="card-text">
                  <strong>Email:</strong> {event.User.email}
                </p>
                <p className="card-text">
                  <strong>Mobile:</strong> {event.User.mobile_number}
                </p>
                <p className="card-text">
                  <strong>Notes:</strong> {event.Description}
                </p>
                <button className="btn" onClick={() => handleShow(event)}>
                  View
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No events available.</p>
        )}
      </div>

      {show && selectedEvent && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">{selectedEvent.EventName}</h5>
            </div>
            <div className="custom-modal-body">
              <p>
                <strong>Description:</strong> {selectedEvent.Description}
              </p>
              <p>
                <strong>Proposed Date:</strong> {selectedEvent.Proposed_Date}
              </p>
              <p>
                <strong>Start Date:</strong> {selectedEvent.Start_Date}
              </p>
              <p>
                <strong>End Date:</strong> {selectedEvent.End_Date}
              </p>
              <div>
                <h2 className="text-center ">Categories</h2>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedEvent.Budget.categories.map((category, index) => (
                      <tr key={index}>
                        <td>{category.type}</td>
                        <td>{category.price}</td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td>
                        <strong>{calculateTotalBudget()}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <strong>Event Budget:</strong>{" "}
                {selectedEvent.Budget.eventBudget}
              </p>
              <p>
                <strong>Status:</strong> {selectedEvent.Status}
              </p>
              <p>
                <strong>User:</strong> {selectedEvent.User.firstName}{" "}
                {selectedEvent.User.lastName}
              </p>
              <p>
                <strong>Email:</strong> {selectedEvent.User.email}
              </p>
              <p>
                <strong>Other Email:</strong> {selectedEvent.email}
              </p>
              <p>
                <strong>Mobile:</strong> {selectedEvent.User.mobile_number}
              </p>
              <p>
                <strong>Other Mobile:</strong> {selectedEvent.mobile_number}
              </p>

              {/* Vendors Table */}
              {selectedEvent.Event_Vendors &&
                selectedEvent.Event_Vendors.length > 0 && (
                  <div>
                    <h2 className="text-center mt-4">Event Vendors</h2>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Vendor No</th>
                          <th>Service Name</th>
                          <th>Price Range</th>
                          {/* <th>End Price Range</th> */}
                          <th>Address</th>
                          <th>City</th>
                          <th>Category</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Whatsapp Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedEvent.Event_Vendors.map((vendor, index) => (
                          <tr key={index}>
                            <td>{vendor.VendorNo}</td>
                            <td>{vendor.serviceName}</td>
                            <td>{vendor.startPriceRange}</td>
                            {/* <td>{vendor.endPriceRange}</td> */}
                            <td>{vendor.address}</td>
                            <td>{vendor.city}</td>
                            <td>{vendor.category}</td>
                            <td>{vendor.email}</td>
                            <td>{vendor.mobileNumber}</td>
                            <td>{vendor.whatsappNumber}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              <div className="custom-modal-header">
                <h5 className="custom-modal-title">
                  Event Coordinator Details
                </h5>
              </div>
              <p className="card-text">
                <strong>Name:</strong> {selectedEvent.Coordinator?.firstName}{" "}
                {selectedEvent.Coordinator?.lastName}
              </p>
              <p className="card-text">
                <strong>Email:</strong> {selectedEvent.Coordinator?.email}
              </p>
              <p className="card-text">
                <strong>Mobile:</strong>{" "}
                {selectedEvent.Coordinator?.mobile_number}
              </p>
            </div>

            <div className="custom-modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleAdd}
              >
                Change Event Co-ordinator
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventMaster;
